@if (isLoading()) {
    <mat-progress-spinner class="in-line-control-rules-spinner" color="primary" mode="indeterminate"></mat-progress-spinner>
} @else {
    <section class="in-line-control-rules__tables-container">
        <div class="in-line-control-rules-tables">
            <app-table
                [isLoading]="isLoading()"
                [isScrollable]="false"
                [sortedColumn]="sortedColumn()"
                [tableColumns]="tableColumns"
                [tableRows]="tableRows$"
                (sortedColumnChange)="onSortedColumnChange($event)">
            </app-table>
        </div>
    </section>
}

